(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SetAgentAccessInfoController', SetAgentAccessInfoController);

    SetAgentAccessInfoController.$inject = ['$scope', '$state', 'AgentSupplierContractCustom'];

    function SetAgentAccessInfoController($scope, $state, AgentSupplierContractCustom) {
        var vm = this;

        vm.loadPage = loadPage;

        loadAll();

        function loadAll() {

            vm.agentSupplierContracts = AgentSupplierContractCustom.getCurrentAgentSuppliers().query();

        }

        function loadPage(page) {

        }

        function transition() {

        }


    }
})();
